// flow weak

import React, {
  PureComponent
}                             from 'react';
import PropTypes              from 'prop-types';
import AnimatedView           from '../../../../components';
import styles                 from './style'
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../../services/fetchTools';
import {Link} from 'react-router-dom';
import { withRouter } from 'react-router';
import TournamentStructure from '../tournamentStructure';
import DatePicker from 'react-datepicker';
import moment from 'moment';

class TournamentCompetition extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func,
    })
  };

  constructor(props) {
    super(props);
    this.state = {
      venues: [],
      sub_categories: {},
      tournament_id : props.match.params.id,
      tournament_name :props.match.params.name,
      games: [],
      mobile_no:'',
      categories: [],
      age_groups: [],
      genders: [],
      coordinaters:[],
      buddy_search_list:[],
      showStructure:false,
      competitions_id:'',
      competition_details : {
              tournament_id: props.match.params.id,
              game:'',
              category:'',
              gender:'',
              age_group:'',
              prize_and_perks:'',
              description:'',
              registration_amount:0,
              coordinaters:[],
              venue:[],
              start_date: moment(),
              end_date: moment(),
              registration_closed: moment(),
            },
      
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.getSearchList = this.getSearchList.bind(this);
    this.setSearch = this.setSearch.bind(this);
    this.handleStartDate = this.handleStartDate.bind(this);
    this.handleEndDate = this.handleEndDate.bind(this);
    this.handleRegDate = this.handleRegDate.bind(this);
    
  }


  componentDidMount() {
    
    this.getTournamentDetails();

  }

 
  getTournamentDetails() {
     const url = `${getLocationOrigin()}/eagleeye/get_inputs_for_add_tournament_competition/`;
     const options = {...defaultOptions};

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => {
         this.setState(
         { venues: data.venues,
           sub_categories: data.sub_categories,
           games: data.games,
           categories: data.categories,
           age_groups: data.age_groups, 
           genders: data.genders
         });
        })
       .catch(error => error);
  }

  handleStartDate(date){
    var new_selected_one =  Object.assign({}, this.state.competition_details);
    new_selected_one['start_date'] = date
    this.setState({competition_details: new_selected_one});
  }
  handleEndDate(date){
    var new_selected_one =  Object.assign({}, this.state.competition_details);
    new_selected_one['end_date'] = date
    this.setState({competition_details: new_selected_one});
  }
  handleRegDate(date){
    var new_selected_one =  Object.assign({}, this.state.competition_details);
    new_selected_one['registration_closed'] = date
    this.setState({competition_details: new_selected_one});
  }

  postCreateCompetition() {
    var data = this.state.competition_details
    console.log(data)
    if(data.age_group == ''){data.age_group = this.state.age_groups[0].id}
    if(data.category == ''){data.category = this.state.categories[0][0]}
    if(data.gender == ''){data.gender = this.state.genders[0][0]}
    if(data.game == ''){data.game = this.state.games[0].pk}
    const url = `${getLocationOrigin()}/tournament/add_tournament_competition/`;
    const options = {...defaultOptions};
    var formData = new FormData();
    options['method'] = 'post';
    options['headers'] = {'content-type': 'application/json'}
    options['body'] = JSON.stringify({  'tournament_id': data.tournament_id,
                                        'registration_amount':data.registration_amount,
                                        'prize_and_perks':data.prize_and_perks,
                                        'category':data.category,
                                        'game':data.game,
                                        'gender':data.gender,
                                        'age_group':data.age_group,
                                        'coordinaters':data.coordinaters,
                                        'venue':data.venue,
                                        'start_date':data.start_date,
                                        'end_date':data.end_date,
                                        'registration_closed':data.registration_closed,
                                        'description':data.description,
                        });

    console.log('Going to fetch');
     return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .then((response) => {  
        alert(response.message); 
          if(response.success){
            this.props.history.goBack();
          }
        })
      .catch(error => {
        console.log(error);
        alert(error.message);
      });
      //this.setState({showStructure:true,ShowCompetition:false,addNewCompetitionView:false});

  }

  getSearchList() {
        var mobile_no = this.state.mobile_no
        const url = `${getLocationOrigin()}/eagleeye/search_buddy/`;
        const options = {...defaultOptions};
        options['method'] = 'post';
        options['headers'] = {'content-type': 'application/json'}
        options['body'] = JSON.stringify({
                             'search': mobile_no
                           });
        return fetch(url, options)
           .then(checkStatus)
           .then(parseJSON)
           .then(data => this.setState({buddy_search_list: data.results, search: true}))
           .catch(error => {
             console.log(error);
             alert(error.message);
           });
    }
  setSearch(name, buddy_id, mobile_no){
        var new_selected_one =  Object.assign({}, this.state.competition_details);
        new_selected_one.coordinaters.push(buddy_id)
        this.setState({competition_details: new_selected_one, search: false});
        this.state.coordinaters.push([buddy_id,name]);
    }
  setCordinater(name, buddy_id, mobile_no){
        var new_selected_one =  Object.assign({}, this.state.prev_competition_details);
        new_selected_one.coordinator.push([buddy_id,name])
        this.setState({prev_competition_details: new_selected_one, search: false});
  }

  removeCoordinater(name,coordinator_id){
        var new_selected_one =  Object.assign({}, this.state.competition_details);
        
        new_selected_one.coordinaters.pop(coordinator_id)
        this.setState({competition_details: new_selected_one, search: false});
        this.state.coordinaters.pop([coordinator_id,name]);
  }
  
 
  handleChangeForNew(event){
    console.log(event.target.name,event.target.value)
    var name = event.target.name
    if(name== 'mobile_no'){
       this.setState({mobile_no:event.target.value})
    }
    else {
      
          var new_selected_one =  Object.assign({}, this.state.competition_details);
          new_selected_one[name] = event.target.value
          this.setState({competition_details: new_selected_one});
        
    }
  }
  handleMultiselect(event) {
    const name = event.target.name;
    var options = event.target.options;
    var new_selected_one =  Object.assign({}, this.state.competition_details);
    var ids = []

    if(event){
       for (var i = 0, l = options.length; i < l; i++) {
              if (options[i].selected) {
                ids.push(options[i].value);
              }
          }
    }
    else{}
     new_selected_one[name] = ids; 
    this.setState({competition_details: new_selected_one});
  }
 
  deleteCompetition(){
        const url = `${getLocationOrigin()}/tournament/delete_tournament_competition/`;
        const options = {...defaultOptions};
        options['method'] = 'post';
        options['headers'] = {'content-type': 'application/json'}
        options['body'] = JSON.stringify({
                             'competition_id': this.state.prev_competition_details.id
                           });
        return fetch(url, options)
           .then(checkStatus)
           .then(parseJSON)
           .then(data => 
                {alert(data.message)
                window.location.reload()
              }
            )
           .catch(error => {
             console.log(error);
             alert(error.message);
           });
  }
  
  handleSubmit(event) {
    event.preventDefault();
    this.postCreateCompetition();
    
  }
  handleCancel(){
    this.props.history.goBack();
  }
  render() {
    console.log(this.state);
    console.log("in render");
    return(
      <div>
        <div className="col-md-12" >
            <div className="breadcrumps" style={{'paddingLeft': "1%",'paddingTop':"1%"}}>
                            <a href={'/#/partnerTournament'} >
                              <span>Events</span>
                            </a> 
                            <a  href={"/#/crud/viewTournament/" + this.state.tournament_id}>
                              <span>{this.state.tournament_name}</span>
                            </a>
                            <a href={`/#/crud/addCompetition/${this.state.tournament_id}/${this.state.tournament_name}`} >
                              <span>Add Competition</span>
                            </a>
            </div>
        </div>
      <div style={styles.container}>
      
        <div className="row col-md-8 table-bordered" style={styles.table}>
          <div style={styles.main_header} className="col-md-12">
            Add Competition
          </div>
          <form  className="validated-form form-horizontal" onSubmit={this.handleSubmit}> 
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Game 
              </div>
              <select name="game" className="col-md-5"  style={styles.item_body} value={this.state.value} 
                onChange={(e) =>{ this.handleChangeForNew(e)}}>
                {
                  this.state.games.map((x, index) => (
                  <option key={x.pk} value={x.pk}>{x.name}</option>
                  ))
                }
              </select>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Category
              </div>
              <select name="category" className="col-md-5" style={styles.item_body} value={this.state.value} 
                onChange={(e) =>{ this.handleChangeForNew(e)}}>
                {
                  this.state.categories.map((format, index) => (
                  <option key={index} value={format[0]}>{format[1]}</option>
                  ))
                }
              </select>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Gender
              </div>
              <select name="gender" className="col-md-5" style={styles.item_body} value={this.state.value} 
                onChange={(e) =>{ this.handleChangeForNew(e)}}>
                {
                  this.state.genders.map((format, index) => (
                  <option key={index} value={format[0]}>{format[1]}</option>
                  ))
                }
              </select>
            </div>

            
           
             <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Age Group
              </div>
              <select name="age_group" id="age_group" className="col-md-5" style={styles.item_body} value={this.state.value} 
                onChange={(e) =>{ this.handleChangeForNew(e)}}>
                {
                  this.state.age_groups.map((age_group, index) => (
                  <option key={index} value={age_group.id}>{age_group.name}</option>
                  ))
                }
              </select>
              
            </div>
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Start Date
              </div>
              <DatePicker selected={this.state.competition_details.start_date} onChange={this.handleStartDate}/>
            </div>

             <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                End Date
              </div>
              <DatePicker selected={this.state.competition_details.end_date} onChange={this.handleEndDate}/>
            </div>
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Registration End Date
              </div>
              <DatePicker selected={this.state.competition_details.registration_closed} onChange={this.handleRegDate}/>
            </div>
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Venues
              </div>
              <select name="venue" id="venue" className="col-md-5" style={styles.item_body} value={this.state.value} multiple={true}
                onChange={(e) =>{this.handleMultiselect(e)}}>
                {
                  Object.keys(this.state.venues).map((key, index) => (
                  <option key={index} value={this.state.venues[key].id}  >{this.state.venues[key].name}</option>
                  ))
                }
              </select>
              
            </div>
            <div style={{textAlign:'right',marginBottom:10}} className="col-md-12">
              <small className="pull-right">* use &lt;Ctrl&gt; for multiple selection</small>
            </div>
            {this.state.coordinaters.length > 0 &&
            <div style={styles.items} className="col-md-12">
                <div style={styles.item_header} className="col-md-6">
                    Selected Coordinaters 
                </div>
                <div  className="col-md-5">
                {this.state.coordinaters.map((coordinator,index) =>
                  <div >{coordinator[1]} <input type="button" value="X" key={index} style={{'backgroundColor':"red"}} onClick={()=>{this.removeCoordinater(coordinator[0],coordinator[1])}} /> </div>
                  )}
                  </div>
            </div>
            }
            <div style={styles.items} className="col-md-12" >
                        <div style={styles.item_header} className="col-md-6">
                            Search Coordinator
                        </div>
                        <div className="col-md-5 input-group">
                                <input type="text" name="mobile_no" className="col-md-10" 
                                placeholder="Search for.. " value={this.state.mobile_no} onChange={(e) =>{this.handleChangeForNew(e)}}/>
                                <span className="input-group-btn">
                                <button className="btn btn-default glyphicon glyphicon-search"
                                type="button" onClick={this.getSearchList}></button>
                                </span>
                         </div>
                    </div>
                        {this.state.search?
                            <div className="col-md-12 btn-group">
                                {this.state.buddy_search_list.length?this.state.buddy_search_list.map((x) =>(<button key={x.mobile_no+x.name} className="btn btn-default"
                            style={{padding:'1%'}} onClick={() => this.setSearch(x.name,x.id, x.mobile_no)}>{x.name}:{x.mobile_no}</button>))
                            :<div className="alert alert-danger" style={{justifyContent: 'space-between', display: 'flex'}}>
                            <div className="alert alert-danger">Search customer not found</div>
                        </div>
                    }</div>:''}
   

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Prize and Perks
              </div>
                <textarea rows="4" cols="33" style={styles.input}  name="prize_and_perks" placeholder="Enter Prize and Perks"
                onChange={(e) =>{ this.handleChangeForNew(e)}} />
            </div>
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Description
              </div>
                <textarea rows="4" cols="33" style={styles.input}  name="description"  placeholder="Enter Competition Description"
                onChange={(e) =>{ this.handleChangeForNew(e)}} />
            </div>
             <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Registration Amount
              </div>
             <input type="number" style={styles.input} name="registration_amount" className="required" 
                value={this.state.value} onChange={(e) =>{ this.handleChangeForNew(e)}}/>
            </div>


            <div style={styles.button_submit} className="col-md-12">

              <input className="button1" type="button" onClick={() => {this.postCreateCompetition()}} value="Create" />
              <input className="button1" type="button" onClick={() => {this.handleCancel()}} value="Cancel" style={{backgroundColor:'red',marginLeft:'10px'}}/>
                
            </div>
            
          </form>
        </div>
      </div>
    </div>
    );
  }
}

export default TournamentCompetition;



// WEBPACK FOOTER //
// ./src/app/views/partner/crud/addCompetition/index.js